var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { injectable } from 'tsyringe';
import { CrudService, Resource } from '../client';
import { resources } from '../resources';
let TranslationService = class TranslationService extends CrudService {
    /**
     * Retrieves an item by its unique ID.
     *
     * @param {string} [namespace] - The name of the requested namespace.
     * @returns {Promise<SimpleResponse<TranslationFromApi>>} A Promise that resolves to a
     * SimpleResponse containing the retrieved item.
     */
    findOne(namespace) {
        return this.client.get(this.route, encodeURIComponent(namespace));
    }
};
TranslationService = __decorate([
    injectable(),
    Resource(resources.translations)
    /**
     * The TranslationsService handles the operations of fetching translations.
     */
], TranslationService);
export { TranslationService };
//# sourceMappingURL=translation.service.js.map